import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable()
export class CandidateOptionsService {

  constructor(private http: HttpClient) {
  }

  getNoteTypes() {
    return this.http.get(`${environment.dataCleanerUrl}/dataClean/getNoteTypes`);
  }

  getActivityFilter() {
    return this.http.get(`${environment.dataCleanerUrl}/dataClean/getActivityFilter`);
  }

  getUsers() {
    return this.http.get(`${environment.dataCleanerUrl}/dataClean/getUsers`);
  }

  getSkills() {
    return this.http.get(`${environment.dataCleanerUrl}/dataClean/getSkills`);
  }

  getCurrentUser() {
    return this.http.get(`${environment.dataCleanerUrl}/dataClean/currentUser`);
  }

  checkAuth() {
    return this.http.get(`${environment.dataCleanerUrl}/auth/checkAuth`);
  }

  checkAdminUser() {
    return this.http.get(`${environment.dataCleanerUrl}/auth/checkAdminUser`);
  }
}
